<template>
  <div class="p-3">
    <template v-if="doingApplication && !notLeavingApplication">
      <p
        class="py-1 text-mild text-size-14 text-weight-500"
        data-testid="doing"
      >
        勤務中
      </p>
      <ApplicationCard
        :application="doingApplication"
        @click="$emit('clickOrderCard', doingApplication.id)"
        class="mb-2"
      />
    </template>

    <template v-if="notAttendingApplication">
      <p
        class="py-1 text-mild text-size-14 text-weight-500"
        data-testid="notAttending"
      >
        未出勤
      </p>
      <ApplicationCard
        :application="notAttendingApplication"
        @click="$emit('clickOrderCard', notAttendingApplication.id)"
        class="mb-2"
      />
    </template>

    <template v-if="notLeavingApplication">
      <p
        class="py-1 text-mild text-size-14 text-weight-500"
        data-testid="notLeaving"
      >
        未退勤
      </p>
      <ApplicationCard
        :application="notLeavingApplication"
        @click="$emit('clickOrderCard', notLeavingApplication.id)"
        class="mb-2"
      />
    </template>

    <template v-if="attendanceCorrections.length > 0">
      <p
        class="py-1 text-mild text-size-14 text-weight-500"
        data-testid="attendanceCorrection"
      >
        勤怠変更未申請
      </p>
      <ApplicationCard
        v-for="application in attendanceCorrections"
        :key="application.id"
        :application="application"
        @click="$emit('clickOrderCard', application.id)"
        class="mb-2"
      />
    </template>

    <p
      v-if="attendanceApplicationCount === 0"
      class="p-3 bg-white text-14 text-center"
      data-testid="noApplication"
    >
      お仕事はありません
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import ApplicationCard from "@/components/organisms/applications/ApplicationCard.vue";
import { applicationStore } from "@/store/application";

@Component({
  components: {
    ApplicationCard
  }
})
export default class ApplicationsAttendanceList extends Vue {
  get doingApplication() {
    return applicationStore.doingApplication;
  }

  get notAttendingApplication() {
    return applicationStore.notAttendingApplication;
  }

  get notLeavingApplication() {
    return applicationStore.notLeavingApplication;
  }

  get attendanceCorrections() {
    return applicationStore.attendanceCorrections;
  }

  get attendanceApplicationCount() {
    return applicationStore.attendanceApplicationCount;
  }
}
</script>
